
<nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" *ngIf="display">
        <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="javascript:void(0)">{{getTitle()}}</a>
    </div>
    <button class="navbar-toggler" type="button" *ngIf="display" (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="isCollapsed">
      <form *ngIf="false">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form>
      <ul class="navbar-nav">
        <li class="nav-item" *ngIf="false">
          <a class="nav-link btn-magnify" href="javascript:void(0)">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>

        <li
          class="nav-item user-avatar"
          ngbDropdown
          placement="bottom-end"
          *ngIf="display"
        >
          <a
            class="avatar-trigger"
            ngbDropdownToggle
            id="navbarUserMenu"
            aria-label="User menu"
          >
            <img
              src="https://api.dicebear.com/9.x/thumbs/svg?seed=Destiny&backgroundColor=FFFFFF"
              alt="User avatar"
              class="avatar-img"
            />
          </a>

          <div
            ngbDropdownMenu
            aria-labelledby="navbarUserMenu"
            class="dropdown-menu dropdown-menu-right user-dropdown"
          >
            <!-- User info -->
            <div class="dropdown-user">
              <img
                src="https://api.dicebear.com/9.x/thumbs/svg?seed=Destiny&backgroundColor=FFFFFF"
                class="avatar-img avatar-lg"
                alt="User avatar"
              />
              <div class="user-meta">
                <div class="user-email" [title]="(userService.currentUser | async)?.email">
                  {{ (userService.currentUser | async)?.email }}
                </div>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <a ngbDropdownItem (click)="goToUserProfile()">Mon compte</a>
            <a ngbDropdownItem (click)="goToInvoices()">Facturation</a>
            <a *ngIf="userService.role !== 'key-user'" ngbDropdownItem (click)="goToNotifications()">Notifications</a>

            <div class="dropdown-divider"></div>

            <a ngbDropdownItem class="text-danger" (click)="logout()">
              Déconnexion
            </a>
          </div>
        </li>
        
        <!--<li class="nav-item">
          <a class="nav-link btn-rotate" href="javascript:void(0)">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>
        -->
      </ul>
    </div>
  </div>
</nav>
